import * as Convert from "./Convert";
import * as DateUtil from "./DateUtil";
import * as PermissionUtil from "./PermissionUtil";
import * as CommonUtil from "./CommonApi";
import * as DictUtil from "./DictUtil";
import * as ApiService from "./ApiService";
import * as Helper from './Helper.js'
export default { Convert, DateUtil,PermissionUtil,CommonUtil,DictUtil,ApiService,Helper };



// WEBPACK FOOTER //
// ./src/util/index.js